import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks"
import authService from '../../services/authService';
import { Box } from '@mui/material';
import { RedirectErrorType } from '../../interfaces';
import { initRedirectError } from '../../app/currentUserSlice';

export default function App() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (searchParams.get(RedirectErrorType.unauthorized)) {
      dispatch(initRedirectError({
        type: RedirectErrorType.unauthorized, appId: searchParams.get("clientId")
      }));
    }
    authService.getUser()
      .then(user => {
        if (user === null) {
          authService.login({ state: { returnUrl: window.location.pathname + window.location.search } });
        } else {
          navigate(`/client${window.location.search}`);
        }
      })
      .catch(() => {
        navigate('/access-deny');
      });
  }, []);

  const signOut = async () => {
      await authService.logout();
  };

  return (
    <React.Fragment>
      <Box>Loading...</Box>
    </React.Fragment>
  );
}
